export const personalizationExplainerAvailableDimensions =
  "/decisioning_studio_agents/:app_group_id/:dsa_id/insights/personalization_explainer/available_dimensions" as const;
